module.exports = __webpack_public_path__ + "029d3fb7fe5d0768eda6a3e1bd073a80.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/official-icons/money.png
// module id = 1670
// module chunks = 0